import { RootState } from "redux/rootReducer";

export const selectIsLoadingConsultationList = (state: RootState) =>
  state.consultationList.loading;
export const selectConsultationListErrorMessage = (state: RootState) =>
  state.consultationList.error;
export const consultationListDataResponse = (state: RootState) =>
  state.consultationList.consultationListResponse;
